"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var react_helmet_1 = require("react-helmet");

exports.SeoDataComponent = function (_a) {
  var data = _a.data;
  var canonical = data.canonical,
      metaDescription = data.metaDescription,
      metaRobotsTag = data.metaRobotsTag,
      openGraphDescription = data.openGraphDescription,
      openGraphImage = data.openGraphImage,
      openGraphTitle = data.openGraphTitle,
      title = data.title;
  return React.createElement(react_helmet_1.Helmet, null, React.createElement("meta", {
    charSet: "utf-8"
  }), title && React.createElement("title", null, title), canonical && React.createElement("link", {
    rel: "canonical",
    href: canonical
  }), metaDescription && React.createElement("meta", {
    name: "description",
    content: metaDescription
  }), metaRobotsTag && React.createElement("meta", {
    name: "robots",
    content: metaRobotsTag
  }), openGraphTitle && React.createElement("meta", {
    property: "og:title",
    content: openGraphTitle
  }), openGraphDescription && React.createElement("meta", {
    property: "og:description",
    content: openGraphDescription
  }), openGraphImage && openGraphImage.file && React.createElement("meta", {
    property: "og:image",
    content: openGraphImage.file.url
  }));
};